import Logo from "../images/Logo.png";
import UserMenu from "./UserMenu";
import NotificationsBell from "./NotificationsBell";
import { useNavigate } from "react-router-dom";

export default function Header() {
    const navigate = useNavigate();
    return (
        <header className="home-header">
            <img src={Logo} alt="DeepThought" className="mobile-header-logo theme-invert" onClick={() => navigate("/")} style={{ cursor: "pointer" }} />
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
                <NotificationsBell />
                <UserMenu />
            </div>
        </header>
    );
}
